import { useTranslation } from 'react-i18next'
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripLines } from '@fortawesome/pro-solid-svg-icons'

import styles from './Order.module.scss'
import { FieldOption } from '../types'

interface OrderProps {
  list: FieldOption[]
  onDragEnd(result: DropResult): void
}

export const Order = ({ list, onDragEnd }: OrderProps) => {
  const { t } = useTranslation()
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-courses">
        {(provided) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className="w-100"
          >
            {list.map(({ option }, index) => (
              <Draggable
                key={index}
                draggableId={index.toString()}
                index={index}
              >
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className={classNames(
                      'd-flex align-items-center p-3 border-bottom justify-content-between',
                      styles.item
                    )}
                  >
                    <div className="d-flex align-items-center user-select-none">
                      <FontAwesomeIcon
                        size="1x"
                        color="#808080"
                        icon={faGripLines}
                        className="mr-2"
                      />
                      <div className="d-flex flex-column">
                        <span>{t(`${option?.label}`)}</span>
                      </div>
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}
